import axios from "axios";

const formatUTCDate = (value) => {
  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return "";

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const formatFaultDate = (value) => {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 200, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },
  { field: "tempSuccionComp1", headerName: "Temp. Succión Comp. 1", minWidth: 200, flex: 1 },
  { field: "tempSuccionComp2", headerName: "Temp. Succión Comp. 2", minWidth: 200, flex: 1 },
  { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 200, flex: 1 },
  { field: "tempProcesoSalida", headerName: "Temp. Proceso Salida", minWidth: 200, flex: 1 },
  { field: "tempTorreEntrada", headerName: "Temp. Torre Entrada", minWidth: 200, flex: 1 },
  { field: "tempTorreSalida", headerName: "Temp. Torre Salida", minWidth: 200, flex: 1 },
  { field: "tempDescargaComp1", headerName: "Temp. Descarga Compresor 1", minWidth: 200, flex: 1 },
  { field: "tempDescargaComp2", headerName: "Temp. Descarga Compresor 2", minWidth: 200, flex: 1 },
  { field: "tempCoThermEntrada", headerName: "Temp. CoTherm Entrada", minWidth: 200, flex: 1 },
  { field: "tempRefrPrecalSalidaC1", headerName: "Temp. Refr Precal Salida Circuito 1", minWidth: 250, flex: 1 },
  { field: "tempCoThermSalida", headerName: "Temp. CoTherm Salida", minWidth: 200, flex: 1 },
  { field: "tempRefrPrecalSalidaC2", headerName: "Temp. Refr Precal Salida Circuito 2", minWidth: 250, flex: 1 },
  { field: "presionSuccionComp1", headerName: "Presión Succión Comp. 1", minWidth: 200, flex: 1 },
  { field: "presionSuccionComp2", headerName: "Presión Succión Comp. 2", minWidth: 200, flex: 1 },
  { field: "presionDescargaComp1", headerName: "Presión Descarga Comp. 1", minWidth: 200, flex: 1 },
  { field: "presionDescargaComp2", headerName: "Presión Descarga Comp. 2", minWidth: 200, flex: 1 },
  { field: "voltajeCmp1", headerName: "Voltaje Comp. 1", minWidth: 200, flex: 1 },
  { field: "voltajeCmp2", headerName: "Voltaje Comp. 2", minWidth: 200, flex: 1 },
  { field: "amperajeCmp1", headerName: "Amperaje Comp. 1", minWidth: 200, flex: 1 },
  { field: "amperajeCmp2", headerName: "Amperaje Comp. 2", minWidth: 200, flex: 1 },
  { field: "sobrecalentamientoCmp1", headerName: "Sobrecalentamiento Comp. 1", minWidth: 200, flex: 1 },
  { field: "sobrecalentamientoCmp2", headerName: "Sobrecalentamiento Comp. 2", minWidth: 200, flex: 1 },
  { field: "condicionActualComp1", headerName: "Condición Actual Comp. 1", minWidth: 200, flex: 1 },
  { field: "condicionActualComp2", headerName: "Condición Actual Comp. 2", minWidth: 200, flex: 1 },
  { field: "porcentajeCargaComp1", headerName: "Porcentaje Carga Comp. 1 (%)", minWidth: 250, flex: 1 },
  { field: "porcentajeCargaComp2", headerName: "Porcentaje Carga Comp. 2 (%)", minWidth: 250, flex: 1 },
  { field: "leaderSecondaryComp1", headerName: "Leader / Secondary Comp. 1", minWidth: 250, flex: 1 },
  { field: "leaderSecondaryComp2", headerName: "Leader / Secondary Comp. 2", minWidth: 250, flex: 1 },
  { field: "controlCarga", headerName: "Control de Carga", minWidth: 200, flex: 1 },
  { field: "ramploading", headerName: "Ramploading", minWidth: 200, flex: 1 },
  { field: "bajoNivelAceiteComp1", headerName: "Bajo Nivel Aceite Comp. 1", minWidth: 200, flex: 1 },
  { field: "bajoNivelAceiteComp2", headerName: "Bajo Nivel Aceite Comp. 2", minWidth: 200, flex: 1 },
  { field: "switchFlujoAguaCondensacion", headerName: "Switch Flujo Agua Condensación", minWidth: 200, flex: 1 },
  { field: "switchFlujoAguaHelada", headerName: "Switch Flujo Agua Helada", minWidth: 200, flex: 1 },
  { field: "statusTempMotorComp1", headerName: "Status Temp Motor Comp. 1", minWidth: 200, flex: 1 },
  { field: "statusTempMotorComp2", headerName: "Status Temp Motor Comp. 2", minWidth: 200, flex: 1 },
  { field: "interlockComp1", headerName: "Interlock Comp. 1", minWidth: 200, flex: 1 },
  { field: "interlockComp2", headerName: "Interlock Comp. 2", minWidth: 200, flex: 1 },
  { field: "statusMotorProtect1", headerName: "Status MotorProtect 1", minWidth: 200, flex: 1 },
  { field: "statusMotorProtect2", headerName: "Status MotorProtect 2", minWidth: 200, flex: 1 },
  { field: "encendidoComp1", headerName: "Encendido Compresor 1", minWidth: 200, flex: 1 },
  { field: "encendidoComp2", headerName: "Encendido Compresor 2", minWidth: 200, flex: 1 },
  { field: "loadUnloadValvula1Comp1", headerName: "Load/Unload Válvula 1 Comp. 1", minWidth: 250, flex: 1 },
  { field: "loadUnloadValvula2Comp1", headerName: "Load/Unload Válvula 2 Comp. 1", minWidth: 250, flex: 1 },
  { field: "loadUnloadValvula3Comp1", headerName: "Load/Unload Válvula 3 Comp. 1", minWidth: 250, flex: 1 },
  { field: "loadUnloadValvula1Comp2", headerName: "Load/Unload Válvula 1 Comp. 2", minWidth: 250, flex: 1 },
  { field: "loadUnloadValvula2Comp2", headerName: "Load/Unload Válvula 2 Comp. 2", minWidth: 250, flex: 1 },
  { field: "loadUnloadValvula3Comp2", headerName: "Load/Unload Válvula 3 Comp. 2", minWidth: 250, flex: 1 },
  { field: "ventiladorTorre", headerName: "Ventilador de Torre", minWidth: 200, flex: 1 },
  { field: "encendidoCoThermC1", headerName: "Encendido Co-Therm C1", minWidth: 200, flex: 1 },
  { field: "encendidoCoThermC2", headerName: "Encendido Co-Therm C2", minWidth: 200, flex: 1 },
  { field: "valvulaLiquidoComp1", headerName: "Válvula de Líquido Comp. 1", minWidth: 250, flex: 1 },
  { field: "valvulaLiquidoComp2", headerName: "Válvula de Líquido Comp. 2", minWidth: 250, flex: 1 },
  { field: "fechaFalla1", headerName: "Fecha de Falla 1", minWidth: 200, flex: 1 },
  { field: "numeroFalla1", headerName: "Número de Falla 1", minWidth: 300, flex: 1 },
  { field: "fechaFalla2", headerName: "Fecha de Falla 2", minWidth: 200, flex: 1 },
  { field: "numeroFalla2", headerName: "Número de Falla 2", minWidth: 300, flex: 1 },
  { field: "fechaFalla3", headerName: "Fecha de Falla 3", minWidth: 200, flex: 1 },
  { field: "numeroFalla3", headerName: "Número de Falla 3", minWidth: 300, flex: 1 },
  { field: "fechaFalla4", headerName: "Fecha de Falla 4", minWidth: 200, flex: 1 },
  { field: "numeroFalla4", headerName: "Número de Falla 4", minWidth: 300, flex: 1 },
  { field: "fechaFalla5", headerName: "Fecha de Falla 5", minWidth: 200, flex: 1 },
  { field: "numeroFalla5", headerName: "Número de Falla 5", minWidth: 300, flex: 1 },
  { field: "tiempoServicioHoras", headerName: "Tiempo de Servicio en Horas", minWidth: 250, flex: 1 },
  { field: "horasTotalesOperacion", headerName: "Horas Totales de Operación", minWidth: 250, flex: 1 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempSuccionComp1: row["Temp. Succion Comp 1"],
  tempSuccionComp2: row["Temp. Succion Comp 2"],
  tempProcesoEntrada: row["Temp. Proceso Entrada"],
  tempProcesoSalida: row["Temp. Proceso Salida"],
  tempTorreEntrada: row["Temp. Torre Entrada"],
  tempTorreSalida: row["Temp. Torre Salida"],
  tempDescargaComp1: row["Temp. Descarga Compresor 1"],
  tempDescargaComp2: row["Temp. Descarga Compresor 2"],
  tempCoThermEntrada: row["Temp. CoTherm Entrada"],
  tempRefrPrecalSalidaC1: row["Temp. Refr Precal Salida Circuito 1"],
  tempCoThermSalida: row["Temp. CoTherm Salida"],
  tempRefrPrecalSalidaC2: row["Temp. Refr Precal Salida Circuito 2"],
  presionSuccionComp1: row["Presion Succion Comp 1"],
  presionSuccionComp2: row["Presion Succion Comp 2"],
  presionDescargaComp1: row["Presion Descarga Comp 1"],
  presionDescargaComp2: row["Presion Descarga Comp 2"],
  voltajeCmp1: row["Voltaje Cmp 1"],
  voltajeCmp2: row["Voltaje Cmp 2"],
  amperajeCmp1: row["Amperaje Cmp 1"],
  amperajeCmp2: row["Amperaje Cmp 2"],
  sobrecalentamientoCmp1: row["Sobrecalentamiento Cmp 1"],
  sobrecalentamientoCmp2: row["Sobrecalentamiento Cmp 2"],
  condicionActualComp1: row["Condicion Actual Comp 1"],
  condicionActualComp2: row["Condicion Actual Comp 2"],
  porcentajeCargaComp1: row["Porcentaje Carga Comp 1 (%)"],
  porcentajeCargaComp2: row["Porcentaje Carga Comp 2 (%)"],
  leaderSecondaryComp1: row["Leader / Secondary Comp 1"],
  leaderSecondaryComp2: row["Leader / Secondary Comp 2"],
  controlCarga: row["Control de Carga"],
  ramploading: row["Ramploading"],
  bajoNivelAceiteComp1: row["Bajo Nivel Aceite Comp. 1"],
  bajoNivelAceiteComp2: row["Bajo Nivel Aceite Comp. 2"],
  switchFlujoAguaCondensacion: row["Switch Flujo Agua Condensacion"],
  switchFlujoAguaHelada: row["Switch Flujo Agual Helada"],
  statusTempMotorComp1: row["Status Temp Motor Comp. 1"],
  statusTempMotorComp2: row["Status Temp Motor Comp. 2"],
  interlockComp1: row["Interlock Comp. 1"],
  interlockComp2: row["Interlock Comp. 2"],
  statusMotorProtect1: row["Status MotorProtect 1"],
  statusMotorProtect2: row["Status MotorProtect 2"],
  arranqueRemoto: row["Arranque Remoto"],
  paroEmergencia: row["Paro de Emergencia"],
  encendidoComp1: row["Encendido Compresor 1"],
  encendidoComp2: row["Encendido Compresor 2"],
  loadUnloadValvula1Comp1: row["Load/Unload Valvula 1 Comp. 1"],
  loadUnloadValvula2Comp1: row["Load/Unload Valvula 2 Comp. 1"],
  loadUnloadValvula3Comp1: row["Load/Unload Valvula 3 Comp. 1"],
  loadUnloadValvula1Comp2: row["Load/Unload Valvula 1 Comp. 2"],
  loadUnloadValvula2Comp2: row["Load/Unload Valvula 2 Comp. 2"],
  loadUnloadValvula3Comp2: row["Load/Unload Valvula 3 Comp. 2"],
  ventiladorTorre: row["Ventilador de Torre"],
  encendidoCoThermC1: row["Encendido Co-Therm C1"],
  encendidoCoThermC2: row["Encendido Co-Therm C2"],
  valvulaLiquidoComp1: row["Valvula de Líquido Comp.1"],
  valvulaLiquidoComp2: row["Valvula de Líquido Comp.2"],
  fechaFalla1: formatFaultDate(row["Fecha de Falla 1"]),
  numeroFalla1: row["Numero de Falla 1"],
  fechaFalla2: formatFaultDate(row["Fecha de Falla 2"]),
  numeroFalla2: row["Numero de Falla 2"],
  fechaFalla3: formatFaultDate(row["Fecha de Falla 3"]),
  numeroFalla3: row["Numero de Falla 3"],
  fechaFalla4: formatFaultDate(row["Fecha de Falla 4"]),
  numeroFalla4: row["Numero de Falla 4"],
  fechaFalla5: formatFaultDate(row["Fecha de Falla 5"]),
  numeroFalla5: row["Numero de Falla 5"],
  tiempoServicioHoras: row["Tiempo de Servicio en Horas"],
  horasTotalesOperacion: row["Horas Totales de Operación"],
});

const fetchRows = async ({ endpoint, idEquipo, fechaInicio, fechaFinal }) => {
  const limit = 1000;
  let offset = 0;
  let allData = [];
  let total = null;

  const fechaInicioSQL = fechaInicio.replace("T", " ") + ":00";
  const fechaFinalSQL = fechaFinal.replace("T", " ") + ":00";

  while (total === null || offset < total) {
    const response = await axios.post(
      endpoint,
      {
        idEquipo,
        fechaInicio: fechaInicioSQL,
        fechaFinal: fechaFinalSQL,
        tipoMaquina: "Optichiller 2Comp CT6",
        tipoConsulta: "Datos",
        limit,
        offset,
      },
      { headers: { "Content-Type": "application/json" } }
    );

    const parsedBody = response.data?.body
      ? typeof response.data.body === "string"
        ? JSON.parse(response.data.body)
        : response.data.body
      : response.data;

    if (!parsedBody.success) {
      throw new Error(parsedBody.message || "La consulta no fue exitosa.");
    }

    const pageData = parsedBody.data || [];

    allData = [...allData, ...pageData];

    total = parsedBody.pagination?.total || pageData.length;

    offset += limit;

    if (pageData.length === 0) break;
  }

  return allData;
};

export const optichiller2CompCT6ConsultaConfig = {
  title: "Optichiller 2Comp CT6",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/optichiller2compct6/datos",
  columns,
  mapRow,
  fetchRows,
};